import tunnel from 'tunnel-rat';

export const SlotBelowCanvas = tunnel();
